import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LihatJadwalPage from './pages/LihatJadwalPage';
import InputJadwalPage from './pages/InputJadwalPage';
import RekapBulananPage from './pages/RekapBulananPage';
import UsersPage from './pages/UsersPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import './index.css';

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main style={{ minHeight: 'calc(100vh - 64px)' }}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
    </>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3500,
              style: { fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 14, fontWeight: 500, borderRadius: 10, boxShadow: '0 10px 25px rgba(0,0,0,0.12)' },
              success: { iconTheme: { primary: '#10B981', secondary: 'white' } },
              error: { iconTheme: { primary: '#EF4444', secondary: 'white' } },
            }}
          />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
            <Route path="/jadwal" element={<ProtectedRoute><Layout><LihatJadwalPage /></Layout></ProtectedRoute>} />
            <Route path="/input" element={<AdminRoute><Layout><InputJadwalPage /></Layout></AdminRoute>} />
            <Route path="/rekap" element={<ProtectedRoute><Layout><RekapBulananPage /></Layout></ProtectedRoute>} />
            <Route path="/users" element={<AdminRoute><Layout><UsersPage /></Layout></AdminRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
            <Route path="/404" element={<Layout><NotFoundPage /></Layout>} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
